import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

/** Fallback shown while a lazy-loaded route chunk is loading (code-splitting). */
export default function PageSkeleton() {
  const { t } = useTranslation();
  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-white dark:bg-gray-900">
      <div className="flex flex-col items-center gap-3">
        <div className="w-10 h-10 border-2 border-gray-300 dark:border-gray-600 border-t-gray-600 dark:border-t-gray-300 rounded-full animate-spin" />
        <span className="text-sm text-gray-500 dark:text-gray-400">{t('common.loading')}</span>
      </div>
    </div>
  );
}
